import React, { useState, useEffect } from 'react';
import List from '@material-ui/core/List';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Collapse } from '@material-ui/core';
import { useStyles } from './styles';
import { getColors } from '@styles/colorsTheme';
import LinkMenu from './LinkActiveMenu';
import ListItem from './ListItemActive';
import { useAuth } from '@hooks/AuthenticateContext';

import {
  routesAdminMenu,
  IRouteMenu,
} from '@router/routes/Cliente.admin.config.routes';


import { routesOperacionalMenu } from '@router/routes/Cliente.operacional.config.routes';
import { routesAdminExpedicaoMenu } from '@router/routes/Cliente.admin.expedicao.config.routes';
import { routesAdminFinanceiroMenu } from '@router/routes/Cliente.admin.financeiro.config.routes';
import { routesAdminFinanceiroExpedicaoMenu } from '@router/routes/Cliente.admin.finan-exped.config.routes';
import { routesOperacionalFinanceiroMenu } from '@router/routes/Cliente.operacional.financeiro.config.routes';
import { routesOperacionalExpedicaoMenu } from '@router/routes/Cliente.operacional.expedicao.config.routes';
import { routesOperacionalBaseMenu } from '@router/routes/Cliente.operacional.base.config.routes';
import { routesOperacionalCoordenadorCaravanaMenu } from '@router/routes/Cliente.operacional.coordenadorcaravana.config.routes';

import { routesAdminMenu as routesAMEXAdminMenu } from '@router/routes/Amex.admin.config.routes';

interface IListProps {
  menuOpen: boolean;
  isDesktop: boolean;
  openToMenu?: Function;
}

const SelectedListItem: React.FC<IListProps> = ({
  menuOpen,
  isDesktop,
  openToMenu,
}) => {
  const { user } = useAuth();
  const classes = useStyles();
  const [, setSelectedIndex] = useState(0);
  const [open, setOpen] = useState(0);
  const [linkRoutes, setLinkRoutes] = useState<IRouteMenu[]>([]);

  const handleListItemClick = (index: number) => {
    setSelectedIndex(index);
    const value = index === open ? 0 : index;
    setOpen(value);

    isDesktop && openToMenu && openToMenu();
  };

  useEffect(() => {
    if (user.role === 'ADM CLIENTE - GESTOR') {
      setLinkRoutes(routesAdminMenu);
    } else if (user.role === 'ADM SOCIALLIS') {
      setLinkRoutes(routesAMEXAdminMenu);
    } else if (user.role === 'ADM CLIENTE - FINANCEIRO') {
      setLinkRoutes(routesAdminFinanceiroMenu);
    } else if (user.role === 'ADM CLIENTE - EXPEDIÇÃO'){
      setLinkRoutes(routesAdminExpedicaoMenu);
    } else if (user.role === 'ADM CLIENTE - EXPEDIÇÃO'){
      setLinkRoutes(routesAdminExpedicaoMenu);
    } else if (user.role === 'ADM CLIENTE - FINANCEIRO / EXPEDIÇÃO'){
      setLinkRoutes(routesAdminFinanceiroExpedicaoMenu);
    } else if (user.role === 'OPERACIONAL - EXPEDIÇÃO'){
      setLinkRoutes(routesOperacionalExpedicaoMenu);
    } else if (user.role === 'OPERACIONAL - FINANCEIRO'){
      setLinkRoutes(routesOperacionalFinanceiroMenu);
    } else if (user.role === 'OPERACIONAL - BASE') {
      setLinkRoutes(routesOperacionalBaseMenu);
    } else if (user.role === 'OPERACIONAL - COORDENADOR CARAVANA') {
      setLinkRoutes(routesOperacionalCoordenadorCaravanaMenu);
    }
  }, [user]);

  return (
    <div className={classes.root}>
      <List component="nav">
        {linkRoutes
          .filter(item => item.menu === 'lateral')
          .map((Item: any) => {
            if (!Item.roles.includes(user.role)) {
              return <></>;
            } else {
              return !Item.subMenu ? (
                <LinkMenu key={Item.index} to={Item.path} label={Item.label}>
                  <Item.Icon htmlColor={getColors()?.branco + '80'} />
                </LinkMenu>
              ) : (
                <List key={Item.index}>
                  <ListItem
                    to={Item.path}
                    onClick={() => handleListItemClick(Item.index)}
                  >
                    <div className={classes.itemList}>
                      <ListItemIcon>
                        <Item.Icon htmlColor={getColors()?.branco + '80'} />
                      </ListItemIcon>
                      <ListItemText
                        style={{ color: getColors()?.branco + '80' }}
                        primary={Item.label}
                      />
                    </div>
                  </ListItem>
                  <Collapse
                    in={menuOpen && open === Item.index}
                    timeout="auto"
                    unmountOnExit
                    style={{ backgroundColor: '#BE638D 33' }}
                  >
                    <List component="div" disablePadding>
                      {Item.subMenu.map(
                        (subMenu: any, keySubMenu: number) =>
                          subMenu.roles.includes(user.role) && (
                            <LinkMenu
                              key={keySubMenu}
                              label={subMenu.label}
                              to={subMenu.path}
                            >
                              <ListItemIcon />
                            </LinkMenu>
                          ),
                      )}
                    </List>
                  </Collapse>
                </List>
              );
            }
          })}
      </List>
    </div>
  );
};

export default SelectedListItem;
